var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWarning)?_c('Alert',{attrs:{"in-page":"","allow-dismiss":true,"data-testid":"ie-warning","type":"warning","text":"You may experience issues running this application in this browser.","subtext":"Please use Google Chrome, Safari or Microsoft Edge"},on:{"dismiss":_vm.acknowledge}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }